import { useNavigate } from 'react-router'
import { ButtonSecondary } from '../../../../../../baseComponents/Button'
import { ModalBigCentered } from '../../../../../../baseComponents/Modal'
import TwinIcon, { TwinIconProp } from '../../../../../../baseComponents/TwinIcon'
import { RowData } from '../../../../../../baseComponents/TwinTable/types'
import TwinTrans from '../../../../../../baseComponents/TwinTrans'
import locations from '../../../../../../utils/globals/locations'
import { SetEditDeleteModalTy } from '../../../../../../utils/hooks/useEditDeleteModal'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { faBallotCheck, faFile, faFileInvoice, faFileLines } from '@fortawesome/pro-light-svg-icons'
import './modalQuickAccessOrder.sass'
import { Fragment } from 'react'

interface ModalQuickAccessOrderProps extends QuickAccessButtonsProps {
    setOpenModal: SetEditDeleteModalTy
}

const ModalQuickAccessOrder: React.FC<ModalQuickAccessOrderProps> = ({ setOpenModal, allRowData }) => {
    return (
        <ModalBigCentered opened={true} setOpened={() => setOpenModal(null)} onClickOut={false} className='flex flex-col modal_quick_access_order'>
            <QuickAccessButtons {...{ allRowData }} />
            <ButtonSecondary onClick={() => setOpenModal(null)} className='w-100 ml-auto mt-30 regular14'>
                <TwinTrans transKey='back'>Volver</TwinTrans>
            </ButtonSecondary>
        </ModalBigCentered>
    )
}

interface QuickAccessButtonsProps { 
    allRowData: RowData
}

const QuickAccessButtons: React.FC<QuickAccessButtonsProps> = ({ allRowData}) => {
    const { t } = useTwinTranslation()
    const { QuoteOrderId, SellOrderId, SellDeliveryNoteId, SellInvoiceId, WorkSheetId, relatedSellOrders, relatedSellDeliveryNotes, relatedSellInvoices, relatedWorkSheets, relatedOrderRefunds } = allRowData
    return (
        <div className='quickaccess_quote_order'>
            <h4 className='text-center'><TwinTrans transKey='quickAccessButtons'>Acceso rápido</TwinTrans></h4>
            <div className='flex flex-col gap-y-15 mt-30'>
                <div className='flex gap-30 flex-auto mx-auto flex-wrap'>
                    {QuoteOrderId ? <QuickAccessButton navigateTo={locations.quoteOrderSingle} text={t('goToQuoteOrder', 'Ir al presupuesto')} icon={faFile} id={QuoteOrderId} /> : null}
                    {SellOrderId ? <QuickAccessButton navigateTo={locations.sellOrderSingle} text={t('goToSellOrder', 'Ir al pedido')} icon={faFileInvoice} id={SellOrderId} /> : null}
                    {relatedSellOrders ? <QuickAccessButtonsRelated navigateTo={locations.sellOrderSingle} text={t('goToSellOrder', 'Ir al pedido')} icon={faFileInvoice} relatedOrders={relatedSellOrders} /> : null}
                    {SellDeliveryNoteId ? <QuickAccessButton navigateTo={locations.sellDeliveryNoteSingle} text={t('goToSellDeliveryNoter', 'Ir al albarán')} icon={faFileLines} id={SellDeliveryNoteId} /> : null}
                    {relatedSellDeliveryNotes ? <QuickAccessButtonsRelated navigateTo={locations.sellDeliveryNoteSingle} text={t('goToSellDeliveryNoter', 'Ir al albarán')} icon={faFileLines} relatedOrders={relatedSellDeliveryNotes} /> : null}
                    {SellInvoiceId ? <QuickAccessButton navigateTo={locations.sellInvoiceSingle} text={t('goToSellInvoice', 'Ir a la factura')} icon={faFileInvoice} id={SellInvoiceId} /> : null}
                    {relatedSellInvoices ? <QuickAccessButtonsRelated navigateTo={locations.sellInvoiceSingle} text={t('goToSellInvoice', 'Ir a la factura')} icon={faFileInvoice} relatedOrders={relatedSellInvoices} /> : null}
                    {WorkSheetId ? <QuickAccessButton navigateTo={locations.workSheetSingle} text={t('goToWorkSheet', 'Ir a la hoja de trabajo')} icon={faBallotCheck} id={WorkSheetId} /> : null}
                    {relatedWorkSheets ? <QuickAccessButtonsRelated navigateTo={locations.workSheetSingle} text={t('goToWorkSheet', 'Ir a la hoja de trabajo')} icon={faBallotCheck} relatedOrders={relatedWorkSheets} /> : null}
                    {relatedOrderRefunds ? <QuickAccessButtonsRelated navigateTo={locations.sellInvoiceRefundSingle} text={t('goToSellInvoiceRefund', 'Ir a la devolución de factura')} icon={faFileInvoice} relatedOrders={relatedOrderRefunds} /> : null}
                </div>
            </div>
        </div>
    )
}

interface QuickAccessButtonBaseProps {
    text: string
    icon: TwinIconProp
    navigateTo: string
}
interface QuickAccessButtonProps extends QuickAccessButtonBaseProps {
    id: number
}

export const QuickAccessButton: React.FC<QuickAccessButtonProps> = ({ id, text, icon, navigateTo }) => {
    const navigate = useNavigate()
    return (
        <div onClick={() => navigate(navigateTo + '/' + id)} className={'order_quickaccess_button flex flex-col px-10 cursor-pointer quickaccess_button py-20'} >
            <TwinIcon icon={icon} className='w-30 h-30 m-auto mb-20' />
            {text}
        </div>
    )
}
interface QuickAccessButtonsRelatedProps extends QuickAccessButtonBaseProps {
    relatedOrders: number[]
}

export const QuickAccessButtonsRelated: React.FC<QuickAccessButtonsRelatedProps> = ({ relatedOrders, text, icon, navigateTo }) => {
    const renderThis: JSX.Element[] = []
    if (relatedOrders.length) {
        for (const key in relatedOrders) {
            const element = relatedOrders[key]
            renderThis.push(<QuickAccessButton id={element} text={text + ' ' + (parseInt(key) + 1)} icon={icon} navigateTo={navigateTo}/>)
        }
    }
    return (<Fragment>
        {renderThis}
    </Fragment>
    )
}

export default ModalQuickAccessOrder